import type { FC } from "react";
import styled from "styled-components";

import aeviLogoShort from "./source/Aevi_Icon_lightgreen.png";
import aeviLogo from "./source/logo-aevi.png";
import aeviLogoInverse from "./source/logo-aevi-inverse.png";
import aeviLogoRebrand from "./source/logo-aevi-rebrand.png";

/**
 * Enum representing the available sizes
 * */
export enum LogoSize {
    SMALL = "small",
    REGULAR = "regular",
    BIG = "big",
}

/**
 * Enum representing all png images in the project
 * */
export enum Logos {
    AeviLogoInverse = "AeviLogoInverse",
    AeviLogo = "AeviLogo",
    AeviLogoRebrand = "AeviLogoRebrand",
    AeviLogoShort = "AeviLogoShort",
}

/**
 * Mapping of the image resource to the enum for better autocompletion
 * */
const logosMap = new Map<Logos, string | unknown>([
    [Logos.AeviLogoInverse, aeviLogoInverse],
    [Logos.AeviLogo, aeviLogo],
    [Logos.AeviLogoRebrand, aeviLogoRebrand],
    [Logos.AeviLogoShort, aeviLogoShort],
]);

/**
 * Properties of the Logo component
 * */
type LogoProps = Readonly<{
    src: Logos;
    size: LogoSize;
}>;

/**
 * Component for pictures in .png format
 * @param src source of the png image
 * @param width width of the image
 * */
export const Logo: FC<LogoProps> = ({ src, size }) => {
    const logo = logosMap.get(src);
    if (typeof logo === "string") {
        return <FlexLogo alt="Logo" src={logo} $size={size} />;
    }
    throw new Error("Could not set up png logo.");
};

const FlexLogo = styled.img<{ $size?: LogoSize }>`
    display: block;
    margin: 0 auto;

    padding: ${(props) => (props.$size === LogoSize.SMALL ? "10px 0" : "20px")};
    width: ${(props) => (props.$size === LogoSize.SMALL ? "40px" : "140px")};
`;
